// BrowserRouter re-wraps its own setState in startTransition, so the post-payment redirect's
// flushSync cannot flush it - only Sync lanes are flushed. Setting this to 'false' makes those
// updates synchronous instead. Undefined here means the prop is not passed at all, which is the
// router's current behaviour; only the literal string 'false' changes anything.
export const resolvedRouterUseTransitions = process.env.REACT_APP_ROUTER_USE_TRANSITIONS === 'false' ? false : undefined;
